import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_2 = { class: "fw-bold mb-1" };
const _hoisted_3 = { class: "text-secondary m-0" };
const _hoisted_4 = {
    key: 0,
    class: "text-secondary mt-2 mb-0"
};
const _hoisted_5 = {
    key: 0,
    class: "alert alert-danger mb-3",
    role: "alert"
};
const _hoisted_6 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_7 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_8 = {
    key: 0,
    class: "alert alert-danger",
    role: "alert"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "row mb-4" };
const _hoisted_11 = { class: "col-lg-6 col-12" };
const _hoisted_12 = { class: "form-check mb-3" };
const _hoisted_13 = { class: "form-check mb-3" };
const _hoisted_14 = { class: "form-check mb-3" };
const _hoisted_15 = { class: "form-check mb-3" };
const _hoisted_16 = { class: "form-check mb-3" };
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = { class: "form-floating mb-3" };
const _hoisted_19 = { class: "form-floating mb-3" };
const _hoisted_20 = { class: "input-group mb-3" };
const _hoisted_21 = { class: "form-floating" };
const _hoisted_22 = { class: "input-group mb-3" };
const _hoisted_23 = { class: "form-floating" };
const _hoisted_24 = { class: "input-group" };
const _hoisted_25 = { class: "form-floating" };
const _hoisted_26 = { class: "input-group mb-3" };
const _hoisted_27 = { class: "form-floating" };
const _hoisted_28 = { class: "input-group" };
const _hoisted_29 = { class: "form-floating" };
const _hoisted_30 = { class: "input-group" };
const _hoisted_31 = { class: "form-floating" };
const _hoisted_32 = { class: "input-group mb-3" };
const _hoisted_33 = { class: "form-floating" };
const _hoisted_34 = { class: "form-floating mb-3" };
const _hoisted_35 = ["value"];
const _hoisted_36 = { class: "form-floating mb-3" };
const _hoisted_37 = ["value"];
const _hoisted_38 = { class: "form-floating mb-3" };
const _hoisted_39 = ["value"];
const _hoisted_40 = { class: "form-floating mb-3" };
const _hoisted_41 = ["value"];
const _hoisted_42 = { class: "form-floating mb-3" };
const _hoisted_43 = ["value"];
const _hoisted_44 = { class: "form-floating mb-3" };
const _hoisted_45 = { class: "form-floating mb-3" };
const _hoisted_46 = { class: "form-floating mb-3" };
const _hoisted_47 = { class: "form-floating mb-3" };
const _hoisted_48 = { class: "form-floating mb-3" };
const _hoisted_49 = { class: "form-floating mb-3" };
const _hoisted_50 = { class: "form-floating mb-3" };
const _hoisted_51 = { class: "form-floating mb-3" };
const _hoisted_52 = ["value"];
const _hoisted_53 = { class: "form-floating mb-3" };
const _hoisted_54 = { class: "form-floating mb-3" };
const _hoisted_55 = { class: "mb-3" };
const _hoisted_56 = { class: "mb-3" };
const _hoisted_57 = { class: "col-12 col-lg-6" };
const _hoisted_58 = { class: "mb-4" };
const _hoisted_59 = { class: "mb-3" };
const _hoisted_60 = { class: "mb-4" };
const _hoisted_61 = { class: "mb-3" };
const _hoisted_62 = { class: "mb-4" };
const _hoisted_63 = { class: "mb-3" };
const _hoisted_64 = { class: "mb-4" };
const _hoisted_65 = { class: "mb-3" };
const _hoisted_66 = { class: "mb-4" };
const _hoisted_67 = { class: "mb-3" };
const _hoisted_68 = { class: "row mt-4" };
const _hoisted_69 = { class: "col-12 col-lg-6" };
const _hoisted_70 = {
    class: "tab-pane fade",
    id: "print-areas-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "print-areas-tab",
    tabindex: "0"
};
const _hoisted_71 = {
    class: "tab-pane fade",
    id: "product-images-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "product-images-tab",
    tabindex: "0"
};
import { FilterMatchMode } from '@primevue/core/api';
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { MultiSelect, useConfirm } from 'primevue';
import TinyEditor from '@/Components/TinyEditor.vue';
import axios from 'axios';
import PrintAreas from './PrintAreas.vue';
import ProductImages from '@/Tenant/Components/ProductImages.vue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import ProductPriceAddition from '@/Tenant/Components/ProductPriceAddition.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        bottle: Object,
        materials: Object,
        productTypes: Object,
        productShapes: Object,
        colorOptions: Object,
        cooperations: Object,
        printAreaTypes: Object,
        printModes: Object,
        suppliers: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const printAreaKey = ref(0);
        const editBottleForm = useForm({
            artNo: props.bottle?.artNo ?? '',
            name: props.bottle?.name ?? '',
            nameEn: props.bottle?.nameEn ?? '',
            description: props.bottle?.description ?? '',
            descriptionEn: props.bottle?.descriptionEn ?? '',
            volume: props.bottle?.volume ?? 0,
            weight: props.bottle?.weight ?? 0,
            height: props.bottle?.height ?? 0,
            diameter: props.bottle?.diameter ?? 0,
            width: props.bottle.width,
            depth: props.bottle.depth,
            diagonal: props.bottle.diagonal,
            isBestseller: props.bottle?.isBestseller ?? false,
            materialUuid: props.bottle?.materialUuid ?? '',
            productTypeUuid: props.bottle?.productTypeUuid ?? '',
            productShapeUuid: props.bottle?.productShapeUuid ?? '',
            colorOptionUuid: props.bottle?.colorOptionUuid ?? '',
            cooperationUuid: props.bottle?.cooperationUuid ?? '',
            sodastreamSuitable: props.bottle?.sodastreamSuitable ?? false,
            configurationWithoutLidPossible: props.bottle?.configurationWithoutLidPossible ?? false,
            hasFillLineOption: props.bottle?.hasFillLineOption ?? false,
            deliveryDays: props.bottle?.deliveryDays ?? null,
            mouthName: props.bottle?.mouthName ?? null,
            mouthThread: props.bottle?.mouthThread ?? null,
            mouthInnerDiameter: props.bottle?.mouthInnerDiameter ?? null,
            moq: props.bottle?.moq ?? null,
            palletPieces: props.bottle?.palletPieces ?? null,
            packagingUnitPieces: props.bottle?.packagingUnitPieces ?? null,
            supplierUuid: props.bottle?.supplierUuid ?? null,
            supplierArticleNo: props.bottle?.supplierArticleNo ?? null,
            maxVolume: props.bottle?.maxVolume ?? null,
            active: props.bottle?.active ?? false
        });
        const productCategories = ref([]);
        const selectedProductCategories = ref([]);
        const availableBottleVariants = ref([]);
        const selectedBottleVariants = ref([]);
        const availableLids = ref([]);
        const selectedLids = ref([]);
        const availableMouthOptions = ref([]);
        const selectedMouthOptions = ref([]);
        const availablePackages = ref([]);
        const selectedPackages = ref([]);
        onMounted(() => {
            // const modalElement = document.getElementById('createAddress');
            // if (modalElement) {
            //     createAddressModal.value = new Modal(modalElement);
            // }
            loadAvailableProductCategories();
            selectedProductCategories.value = props.bottle?.productCategories.map((category) => {
                return category.uuid;
            }) ?? [];
            loadAvailableBottleVariants();
            selectedBottleVariants.value = props.bottle?.bottleVariants.map((variant) => {
                return variant.uuid;
            }) ?? [];
            loadAvailableLids();
            selectedLids.value = props.bottle?.lids.map((lid) => {
                return lid.uuid;
            }) ?? [];
            loadAvailableMouthOptions();
            selectedMouthOptions.value = props.bottle?.mouthOptions.map((mouthOption) => {
                return mouthOption.uuid;
            }) ?? [];
            loadAvailablePackages();
            selectedPackages.value = props.bottle?.packages.map((packageItem) => {
                return packageItem.uuid;
            }) ?? [];
        });
        function loadAvailableProductCategories() {
            axios.post(route('admin.productCategories.load')).then((response) => {
                productCategories.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadAvailableBottleVariants() {
            axios.post(route('admin.bottleVariants.load')).then((response) => {
                availableBottleVariants.value = response.data;
                if (props.bottle) {
                    availableBottleVariants.value = availableBottleVariants.value.filter((variant) => variant.uuid !== props.bottle.uuid);
                }
            }).catch((error) => {
                showErrorMessage(error);
                console.log(error);
            });
        }
        function loadAvailableLids() {
            axios.post(route('admin.lids.load')).then((response) => {
                availableLids.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadAvailableMouthOptions() {
            axios.post(route('admin.mouthOptions.load')).then((response) => {
                availableMouthOptions.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function loadAvailablePackages() {
            axios.post(route('admin.packages.load')).then((response) => {
                availablePackages.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updateBottle() {
            if (props.bottle == null) {
                return;
            }
            editBottleForm.transform((data) => ({
                art_no: data.artNo,
                name: data.name,
                name_en: data.nameEn,
                description: data.description,
                description_en: data.descriptionEn,
                volume: data.volume,
                weight: data.weight,
                height: data.height,
                diameter: data.diameter,
                width: data.width,
                depth: data.depth,
                diagonal: data.diagonal,
                material_uuid: data.materialUuid,
                product_type_uuid: data.productTypeUuid,
                product_shape_uuid: data.productShapeUuid,
                color_option_uuid: data.colorOptionUuid,
                cooperation_uuid: data.cooperationUuid,
                is_bestseller: data.isBestseller,
                sodastream_suitable: data.sodastreamSuitable,
                configuration_without_lid_possible: data.configurationWithoutLidPossible,
                has_fill_line_option: data.hasFillLineOption,
                delivery_days: data.deliveryDays,
                mouth_name: data.mouthName,
                mouth_thread: data.mouthThread,
                mouth_inner_diameter: data.mouthInnerDiameter,
                moq: data.moq,
                pallet_pieces: data.palletPieces,
                packaging_unit_pieces: data.packagingUnitPieces,
                supplier_uuid: data.supplierUuid,
                supplier_article_no: data.supplierArticleNo,
                max_volume: data.maxVolume,
                active: data.active
            }))
                .submit('put', route('admin.bottles.update', props.bottle.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeBottle() {
            confirm.require({
                message: 'Soll die Flasche wirklich gelöscht werden?',
                header: 'Flasche löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.bottle == null) {
                        return;
                    }
                    router.delete(route('admin.bottles.destroy', props.bottle.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function updateProductCategories() {
            if (props.bottle == null) {
                return;
            }
            if (selectedProductCategories.value.length === 0) {
                showErrorMessage('Bitte wählen Sie mindestens eine Produktkategorie aus.');
                return;
            }
            router.post(route('admin.bottles.productCategories.update', props.bottle.uuid), {
                'productCategoryUuids': selectedProductCategories.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateBottleVariants() {
            if (props.bottle == null) {
                return;
            }
            router.post(route('admin.bottles.variants.update', props.bottle.uuid), {
                'bottleUuids': selectedBottleVariants.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateLids() {
            if (props.bottle == null) {
                return;
            }
            router.post(route('admin.bottles.lids.update', props.bottle.uuid), {
                'lidUuids': selectedLids.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateMouthOptions() {
            if (props.bottle == null) {
                return;
            }
            router.post(route('admin.bottles.mouthOptions.update', props.bottle.uuid), {
                'mouthOptionUuids': selectedMouthOptions.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updatePackages() {
            if (props.bottle == null) {
                return;
            }
            router.post(route('admin.bottles.packages.update', props.bottle.uuid), {
                'packageUuids': selectedPackages.value
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function copyBottle() {
            confirm.require({
                message: 'Soll die Flasche wirklich kopiert werden?',
                header: 'Flasche kopieren?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Ja, Flasche kopieren',
                accept: () => {
                    if (props.bottle == null) {
                        return;
                    }
                    router.post(route('admin.bottles.copy.store', props.bottle.uuid), {}, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Flasche" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_2, "Flasche: " + _toDisplayString(props.bottle.name) + " (" + _toDisplayString(props.bottle.volume) + " ml)", 1),
                                _createElementVNode("p", _hoisted_3, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.bottle.updatedAt, true)), 1),
                                (props.bottle.supplier)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Lieferant: " + _toDisplayString(props.bottle.supplier.name), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                    class: "btn btn-primary text-white d-inline-flex align-items-center",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (copyBottle()))
                                }, [...(_cache[39] || (_cache[39] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-copy",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                                            })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Flasche kopieren", -1)
                                    ]))])
                            ])
                        ]),
                        (props.bottle.priceBundle && !props.bottle.priceBundle.active)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Produkt ist mit einem inaktiven Preis-Bundle verknüpft. Produkt kann somit nicht eingesetzt werden."))
                            : _createCommentVNode("", true),
                        _cache[99] || (_cache[99] = _createElementVNode("ul", {
                            class: "nav nav-underline mb-3",
                            role: "tablist"
                        }, [
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "print-areas-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#print-areas-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "print-areas-tab-pane",
                                    "aria-selected": "false"
                                }, "Druckbereiche")
                            ]),
                            _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "product-images-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#product-images-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "product-images-tab-pane",
                                    "aria-selected": "false"
                                }, "Produkt-Bilder")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (props.bottle && !props.bottle.configurationIsPossible)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Flasche kann aktuell nicht konfiguriert werden!", -1)),
                                        _createElementVNode("span", {
                                            innerHTML: props.bottle.noConfigurationPossibleReasons
                                        }, null, 8, _hoisted_9)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updateBottle, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "active",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editBottleForm).active) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editBottleForm).active]
                                                ]),
                                                _cache[41] || (_cache[41] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "active"
                                                }, "Aktiv (Flasche kann konfiguriert werden)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "isBestseller",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editBottleForm).isBestseller) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editBottleForm).isBestseller]
                                                ]),
                                                _cache[42] || (_cache[42] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "isBestseller"
                                                }, "Bestseller-Flasche", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "isSodastreamSuitable",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editBottleForm).sodastreamSuitable) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editBottleForm).sodastreamSuitable]
                                                ]),
                                                _cache[43] || (_cache[43] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "isSodastreamSuitable"
                                                }, "Soda-Stream-geeignet", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "configurationWithoutLidPossible",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editBottleForm).configurationWithoutLidPossible) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editBottleForm).configurationWithoutLidPossible]
                                                ]),
                                                _cache[44] || (_cache[44] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "configurationWithoutLidPossible"
                                                }, "Konfiguration ohne Verschluss möglich", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "hasFillLineOption",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editBottleForm).hasFillLineOption) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editBottleForm).hasFillLineOption]
                                                ]),
                                                _cache[45] || (_cache[45] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "hasFillLineOption"
                                                }, "Eichstrich-Option konfigurierbar", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "artNo",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editBottleForm).artNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).artNo]
                                                ]),
                                                _cache[46] || (_cache[46] = _createElementVNode("label", { for: "artNo" }, "Artnr.", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editBottleForm).name) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).name]
                                                ]),
                                                _cache[47] || (_cache[47] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "nameEn",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editBottleForm).nameEn) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).nameEn]
                                                ]),
                                                _cache[48] || (_cache[48] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "1",
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editBottleForm).volume) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).volume]
                                                    ]),
                                                    _cache[49] || (_cache[49] = _createElementVNode("label", { for: "volume" }, "Volumen", -1))
                                                ]),
                                                _cache[50] || (_cache[50] = _createElementVNode("span", { class: "input-group-text" }, "ml", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(editBottleForm).weight) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).weight]
                                                    ]),
                                                    _cache[51] || (_cache[51] = _createElementVNode("label", { for: "weight" }, "Gewicht", -1))
                                                ]),
                                                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "input-group-text" }, "g", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(editBottleForm).height) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).height]
                                                    ]),
                                                    _cache[53] || (_cache[53] = _createElementVNode("label", { for: "weight" }, "Höhe", -1))
                                                ]),
                                                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[82] || (_cache[82] = _createElementVNode("p", { class: "form-text mb-3" }, "Exakte Höhe von oben bis unten ohne Toleranz.", -1)),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(editBottleForm).diameter) = $event)),
                                                        required: ""
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).diameter]
                                                    ]),
                                                    _cache[55] || (_cache[55] = _createElementVNode("label", { for: "diameter" }, "Durchmesser", -1))
                                                ]),
                                                _cache[56] || (_cache[56] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(editBottleForm).width) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).width]
                                                    ]),
                                                    _cache[57] || (_cache[57] = _createElementVNode("label", { for: "width" }, "Breite", -1))
                                                ]),
                                                _cache[58] || (_cache[58] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[83] || (_cache[83] = _createElementVNode("p", { class: "form-text mb-3" }, "Relevant bei eckigen Produkten.", -1)),
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(editBottleForm).depth) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).depth]
                                                    ]),
                                                    _cache[59] || (_cache[59] = _createElementVNode("label", { for: "depth" }, "Tiefe", -1))
                                                ]),
                                                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _cache[84] || (_cache[84] = _createElementVNode("p", { class: "form-text mb-3" }, "Relevant bei eckigen Produkten.", -1)),
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        min: "0",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(editBottleForm).diagonal) = $event))
                                                    }, null, 512), [
                                                        [_vModelText, _unref(editBottleForm).diagonal]
                                                    ]),
                                                    _cache[61] || (_cache[61] = _createElementVNode("label", { for: "diagonal" }, "Diagonale", -1))
                                                ]),
                                                _cache[62] || (_cache[62] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "material",
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(editBottleForm).materialUuid) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.materials, (material) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: material.uuid
                                                        }, _toDisplayString(material.name), 9, _hoisted_35));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).materialUuid]
                                                ]),
                                                _cache[63] || (_cache[63] = _createElementVNode("label", { for: "material" }, "Material", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "productType",
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(editBottleForm).productTypeUuid) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productTypes, (productType) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: productType.uuid
                                                        }, _toDisplayString(productType.name), 9, _hoisted_37));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).productTypeUuid]
                                                ]),
                                                _cache[64] || (_cache[64] = _createElementVNode("label", { for: "productType" }, "Produkttyp", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_38, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "productShape",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(editBottleForm).productShapeUuid) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.productShapes, (productShape) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: productShape.uuid
                                                        }, _toDisplayString(productShape.name), 9, _hoisted_39));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).productShapeUuid]
                                                ]),
                                                _cache[65] || (_cache[65] = _createElementVNode("label", { for: "productShape" }, "Form", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_40, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "colorOption",
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(editBottleForm).colorOptionUuid) = $event))
                                                }, [
                                                    _cache[66] || (_cache[66] = _createElementVNode("option", { value: "" }, "Keine Farboption", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.colorOptions, (colorOption) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: colorOption.uuid
                                                        }, _toDisplayString(colorOption.name), 9, _hoisted_41));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).colorOptionUuid]
                                                ]),
                                                _cache[67] || (_cache[67] = _createElementVNode("label", { for: "colorOption" }, "Farboption", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_42, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "cooperation",
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(editBottleForm).cooperationUuid) = $event))
                                                }, [
                                                    _cache[68] || (_cache[68] = _createElementVNode("option", { value: "" }, "Keine Kooperation", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cooperations, (cooperation) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: cooperation.uuid
                                                        }, _toDisplayString(cooperation.name), 9, _hoisted_43));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).cooperationUuid]
                                                ]),
                                                _cache[69] || (_cache[69] = _createElementVNode("label", { for: "cooperation" }, "Kooperation", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_44, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "deliveryDays",
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(editBottleForm).deliveryDays) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).deliveryDays]
                                                ]),
                                                _cache[70] || (_cache[70] = _createElementVNode("label", { for: "deliveryDays" }, "Lieferzeit in Tagen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mouthName",
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(editBottleForm).mouthName) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).mouthName]
                                                ]),
                                                _cache[71] || (_cache[71] = _createElementVNode("label", { for: "mouthName" }, "Mündung - Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_46, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "mouthThread",
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(editBottleForm).mouthThread) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).mouthThread]
                                                ]),
                                                _cache[72] || (_cache[72] = _createElementVNode("label", { for: "mouthThread" }, "Mündung - Gewinde", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "mouthInnerDiameter",
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_unref(editBottleForm).mouthInnerDiameter) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).mouthInnerDiameter]
                                                ]),
                                                _cache[73] || (_cache[73] = _createElementVNode("label", { for: "mouthInnerDiameter" }, "Mündung - Innendurchmesser", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "moq",
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(editBottleForm).moq) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).moq]
                                                ]),
                                                _cache[74] || (_cache[74] = _createElementVNode("label", { for: "moq" }, "MOQ", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "palletPieces",
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_unref(editBottleForm).palletPieces) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).palletPieces]
                                                ]),
                                                _cache[75] || (_cache[75] = _createElementVNode("label", { for: "palletPieces" }, "Stück pro Palette", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "packagingUnitPieces",
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_unref(editBottleForm).packagingUnitPieces) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).packagingUnitPieces]
                                                ]),
                                                _cache[76] || (_cache[76] = _createElementVNode("label", { for: "packagingUnitPieces" }, "Stück pro VPE", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_51, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "supplier",
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_unref(editBottleForm).supplierUuid) = $event))
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.suppliers, (supplier) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: supplier.uuid
                                                        }, _toDisplayString(supplier.name), 9, _hoisted_52));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editBottleForm).supplierUuid]
                                                ]),
                                                _cache[77] || (_cache[77] = _createElementVNode("label", { for: "supplier" }, "Lieferant", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_53, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "supplierArticleNo",
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_unref(editBottleForm).supplierArticleNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).supplierArticleNo]
                                                ]),
                                                _cache[78] || (_cache[78] = _createElementVNode("label", { for: "supplierArticleNo" }, "Lieferantenartikelnummer", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: "maxVolume",
                                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_unref(editBottleForm).maxVolume) = $event)),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 512), [
                                                    [_vModelText, _unref(editBottleForm).maxVolume]
                                                ]),
                                                _cache[79] || (_cache[79] = _createElementVNode("label", { for: "maxVolume" }, "Randvollvolumen", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_55, [
                                                _cache[80] || (_cache[80] = _createElementVNode("label", {
                                                    for: "description",
                                                    class: "mb-2"
                                                }, "Beschreibung", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "description",
                                                    modelValue: _unref(editBottleForm).description,
                                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((_unref(editBottleForm).description) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                                _cache[81] || (_cache[81] = _createElementVNode("label", {
                                                    for: "descriptionEn",
                                                    class: "mb-2"
                                                }, "Beschreibung (en)", -1)),
                                                _createVNode(TinyEditor, {
                                                    id: "descriptionEn",
                                                    modelValue: _unref(editBottleForm).descriptionEn,
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_unref(editBottleForm).descriptionEn) = $event)),
                                                    height: 300
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _cache[85] || (_cache[85] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 32),
                                        (props.bottle.canRemove)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                                onClick: removeBottle
                                            }, [...(_cache[86] || (_cache[86] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-x-circle",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                        _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Flasche löschen", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                            _cache[88] || (_cache[88] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Produktkategorien", -1)),
                                            _createElementVNode("div", _hoisted_59, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedProductCategories.value,
                                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((selectedProductCategories).value = $event)),
                                                    options: productCategories.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Produktkategorien wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateProductCategories
                                            }, [...(_cache[87] || (_cache[87] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_60, [
                                            _cache[90] || (_cache[90] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Flaschen-Varianten", -1)),
                                            _createElementVNode("div", _hoisted_61, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedBottleVariants.value,
                                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((selectedBottleVariants).value = $event)),
                                                    options: availableBottleVariants.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Flaschen-Varianten wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateBottleVariants
                                            }, [...(_cache[89] || (_cache[89] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                            _cache[92] || (_cache[92] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Verschlüsse", -1)),
                                            _createElementVNode("div", _hoisted_63, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedLids.value,
                                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((selectedLids).value = $event)),
                                                    options: availableLids.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Verschlüsse wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateLids
                                            }, [...(_cache[91] || (_cache[91] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                            _cache[94] || (_cache[94] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Verschluss-Mündungen", -1)),
                                            _createElementVNode("div", _hoisted_65, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedMouthOptions.value,
                                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((selectedMouthOptions).value = $event)),
                                                    options: availableMouthOptions.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Verschluss-Mündungen wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updateMouthOptions
                                            }, [...(_cache[93] || (_cache[93] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                            _cache[96] || (_cache[96] = _createElementVNode("h3", { class: "fw-bold text-primary mb-3" }, "Verpackungen", -1)),
                                            _createElementVNode("div", _hoisted_67, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: selectedPackages.value,
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((selectedPackages).value = $event)),
                                                    options: availablePackages.value,
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: "Verpackungen wählen"
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success d-inline-flex align-items-center",
                                                onClick: updatePackages
                                            }, [...(_cache[95] || (_cache[95] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                ]))])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _cache[98] || (_cache[98] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preise", -1)),
                                    _createVNode(ProductPriceOption, {
                                        bottle: props.bottle,
                                        priceBundleUuid: props.bottle.priceBundleUuid
                                    }, null, 8, ["bottle", "priceBundleUuid"]),
                                    _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("div", _hoisted_69, [
                                            _cache[97] || (_cache[97] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Preis-Aufschlag", -1)),
                                            _createVNode(ProductPriceAddition, {
                                                bottle: props.bottle
                                            }, null, 8, ["bottle"])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                                (_openBlock(), _createBlock(PrintAreas, {
                                    bottle: props.bottle,
                                    printAreaTypes: props.printAreaTypes,
                                    printModes: props.printModes,
                                    key: printAreaKey.value,
                                    onUpdate: _cache[38] || (_cache[38] = ($event) => (printAreaKey.value++))
                                }, null, 8, ["bottle", "printAreaTypes", "printModes"]))
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                                _createVNode(ProductImages, {
                                    bottle: props.bottle
                                }, null, 8, ["bottle"])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
